<template>
  <div
    class="login-text"
    v-html="$sanitize(welcomeText)" />
</template>

<script>
import { mapState } from 'vuex';
import _escape from 'lodash/escape';

export default {
  name: 'ShareLoginMessage',
  computed: {
    ...mapState({
      currentRulesKey: (state) => state.currentRulesKey,
    }),
    shareData() {
      return this.$store.state[this.currentRulesKey]?.welcome || {};
    },
    welcomeText() {
      switch (this.$route.name) {
        case 'download':
          if (this.shareData.is_reply) {
            return this.$gettextInterpolate(
              this.$gettext(
                '%{ sender } has shared files with you as requested. %{ breakTag } Please log in to download your files.'
              ),
              {
                sender: _escape(this.shareData.sender_name),
                breakTag: '<br/>',
              },
              true
            );
          }
          switch (this.shareData.share_type) {
            case 'C':
              return this.$gettextInterpolate(
                this.$gettext(
                  '%{ sender } has shared files with you using Quatrix.%{ breakTag } The sender requires you to log in to download files.'
                ),
                {
                  breakTag: '<br>',
                  sender: _escape(this.shareData.sender_name),
                },
                true
              );
            case 'T':
              return this.$gettextInterpolate(
                this.$gettext(
                  '%{ sender } has shared files with you using Quatrix.%{ breakTag } The sender requires you to log in to download files.'
                ),
                {
                  breakTag: '<br>',
                  sender: _escape(this.shareData.sender_name),
                },
                true
              );
            case 'P':
              return this.$gettextInterpolate(
                this.$gettext(
                  '%{ sender } has shared files with you using Quatrix.%{ breakTag } The sender requires you to enter security PIN code to download files.'
                ),
                {
                  breakTag: '<br>',
                  sender: _escape(this.shareData.sender_name),
                },
                true
              );
            default:
              return '';
          }
        case 'files-return':
          if (this.shareData.share_type === 'C') {
            return this.$gettextInterpolate(
              this.$gettext(
                '%{ sender } has requested files from you using Quatrix.%{ breakTag } The sender requires you to log in to return files.'
              ),
              {
                breakTag: '<br>',
                sender: _escape(this.shareData.sender_name),
              },
              true
            );
          }
          return this.$gettextInterpolate(
            this.$gettext(
              '%{ sender } has requested files from you using Quatrix.%{ breakTag } The sender requires you to log in to return files.'
            ),
            {
              breakTag: '<br>',
              sender: _escape(this.shareData.sender_name),
            },
            true
          );
        case 'key-request':
          return this.$gettextInterpolate(
            this.$gettext(
              '%{ sender } has requested that you generate or regenerate your PGP keys.%{ breakTag } The sender requires you to log in to generate your keys.'
            ),
            {
              breakTag: '<br>',
              sender: _escape(this.shareData.sender_name),
            },
            true
          );
        default:
          return '';
      }
    },
  },
};
</script>
